import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import App from './App.vue'
import './css/tachyons.min.css'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')
